import {
	type ApplicationEdition,
	type ApplicationEditionKey,
	PREMIUM_EDITION_KEY,
	STANDARD_EDITION_KEY,
} from '@jira/platform__application-editions/src/edition.tsx';

export const EDITION_KEY: Partial<Record<ApplicationEdition, ApplicationEditionKey>> = {
	STANDARD_EDITION: STANDARD_EDITION_KEY,
	PREMIUM_EDITION: PREMIUM_EDITION_KEY,
};
